module.exports = __webpack_public_path__ + "static/img/103.70a39d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/103.jpg
// module id = smT5
// module chunks = 42